<order-details-desktop *ngIf="!isMobile"></order-details-desktop>
<order-details-mobile *ngIf="isMobile"></order-details-mobile>